var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyright layout-row layout-hv-center color-white bg-pink1"},[_vm._v("\n\tCopyright © "+_vm._s(_vm.copyright)+" 社團法人臺灣童心創意行動協會 | All Rights Reserved.\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }